import React, { Component } from "react";
import PropTypes from "prop-types";

import { Star } from "components/icons/Star";
import { StarOutline } from "components/icons/StarOutline";

export class ProductReviewStars extends Component {
  constructor (props) {
    super(props);

    this.state = {
      rating: this.props.rating,
      hovering: 0
    };

    this.renderStars = this.renderStars.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  onClick (index) {
    return () => {
      let newRating = (this.state.rating === index && index === 1)
        ? 0
        : index;

      this.setState({
        rating: newRating
      });

      (this.props.updateCallback(newRating) || this.forceUpdate());
    };
  }

  onMouseOver (index) {
    return () => {
      this.setState({
        hovering: index
      });
    };
  }

  onMouseLeave () {
    return () => {
      this.setState({
        hovering: 0
      });
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.rating !== this.state.rating) {
      this.setState({
        rating: this.props.rating
      });
    }
  }

  renderStars () {
    let {
      hovering,
      rating
    } = this.state;

    let returnable = [];

    for (let i = 0; i < 5; i++) {
      let currentId = i + 1;

      if (
        hovering >= currentId
        || rating >= currentId
      ) {
        returnable.push(
          <span
            key={i}
            onClick={this.onClick(currentId)}
            onMouseOver={this.onMouseOver(currentId)}
            onMouseLeave={this.onMouseLeave(currentId)}>
            <Star
              fill={"#FF7DA4"}/>
          </span>
        );
      } else {
        returnable.push(
          <span
            key={i}
            onClick={this.onClick(currentId)}
            onMouseOver={this.onMouseOver(currentId)}
            onMouseLeave={this.onMouseLeave(currentId)}>
            <StarOutline
              fill={"#FF7DA4"}/>
          </span>
        );
      }
    }
    
    return returnable;
  }

  render () {
    return (
      <div className={"productReviewStarsTempClassName"}>
        {this.renderStars()}
      </div>
    );
  }
}

ProductReviewStars.defaultProps = {
  rating: 0
};

ProductReviewStars.propTypes = {
  rating: PropTypes.number,
  updateCallback: PropTypes.func.isRequired
};
